import type { RouteRecordRaw } from 'vue-router';
import { ERouteName } from '~/app/router/routeName.enum';

export const userPageRoutes: RouteRecordRaw = {
  path: '/user',
  component: () => import('@/pages/user/UserPage.vue'),
  meta: {
    isSearchHiddenOnMobileAndTablet: true,
    isTopHeaderHiddenOnMobileAndTablet: true,
  },
  children: [
    {
      path: '',
      name: ERouteName.USER,
      redirect: 'user/orders',
    },

    {
      path: 'orders',
      name: ERouteName.USER_ORDERS,
      component: () => import('@/pages/user/orders/UserPageOrders.vue'),
      meta: {
        title: 'Мои заказы',
      },
    },

    {
      path: 'settings',
      name: ERouteName.USER_SETTINGS,
      component: () => import('~/pages/user/settings/UserPageSettings.vue'),
      meta: {
        title: 'Мои данные',
      },
    },
  ],
};
